window['ThemeSection_ProductQuickBuy'] = ({
  product,
  variant,
  featuredMediaID,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    addedToCart: false,
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get current_price() {
      return this.current_variant.price;
    },
    formatMoney(price) {
      return formatMoney(price, theme.moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;
      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }
      this.getOptions();
    },
    mainSelectorChange() {
      const matchedVariant = ShopifyProduct.getVariantFromId(
        this.product,
        parseInt(this.$refs.singleVariantSelector.value)
      );
      this.updateVariant(matchedVariant);
    },
    optionChange() {
      // console.log('first')
      this.getOptions();
      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );
      this.updateVariant(matchedVariant);
    },
    updateVariant(variant) {
      this.current_variant = variant;
      if (this.current_variant) {
        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    async submitForm(evt) {
      evt.preventDefault();
      if (this.loading) return;
      this.loading = true;
      this.addedToCart = false;
      liveRegion(window.theme.strings.loading);
      try {
        const formData = new FormData(this.$root.querySelector('.quick-buy-product-form'));
        const modalCart = theme.settings.cart_type === 'modal';
        if (modalCart) {
          formData.set('sections', ThemeCart.sections);
          formData.set('sections_url', window.location.pathname);
        }
        const config = fetchConfigDefaults('javascript');
        config.body = formData;
        delete config.headers['Content-Type'];
        await ThemeCart.mutate(theme.routes.cart_add_url, config,
          modalCart ? 'shapes:modalcart:afteradditem' : null);
        this.addedToCart = true;
        if (!modalCart) {
          window.location.assign(theme.routes.cart_url || '/cart');
        } else if (!document.querySelector('[data-show-on-add="true"]') && this.$refs.added) {
          this.$nextTick(() => this.$refs.added.focus());
        }
      } catch (error) {
        if (error.cartRecovering) return;
        const message = ThemeCart.errorMessage(error);
        liveRegion(message);
        alert(message);
      } finally {
        this.loading = false;
      }
    },

  };
};
